<template>
  <h2 class="text-3xl leading-tight font-bold">Contatti</h2>
  <p class="text-lg mt-4 font-semibold">WIP</p>
  <p class="mt-2 leading-relaxed">Lorem ipsum.</p>
</template>

<script>
import PageLayout from "@/Pages/Home/Shared/PageLayout.vue";
import { Head } from "@inertiajs/inertia-vue3";

export default {
  components: {
    Head,
  },
  layout: PageLayout,
};
</script>
